export default import.meta.ROLLDOWN_FILE_URL__ygAxo1SXThqFbkT129hvw